// extracted by mini-css-extract-plugin
export default {"pagination":"RcPagination_pagination__vFnPh"};